/**
 * Config Utils class to set all UI Configs to be used throughout the app
 */
export default class ConfigUtils {
    static _configData = null;

    /**
     * Get Input Components
     * @returns InputComponents
     */
    static getInputComponents() {
        return ConfigUtils._configData.inputComponents;
    }
    /**
     * Get Processor Types
     * @returns ProcessorTypes
     */
    static getProcessorTypes() {
        return ConfigUtils._configData.processorType;
    }
    /**
     * Get Delivery Types
     * @returns DeliveryTypes
     */
     static getDeliveryTypes() {
        return ConfigUtils._configData?.deliveryType;
    }
    /**
     * Get Source Mapping
     * @returns SourceMapping
     */
     static getSourceMapping() {
        return ConfigUtils._configData.sourceMapping;
    }
    /**
     * Get Delivery Mapping
     * @returns DeliveryMapping
     */
    static getDeliveryMapping() {
        return ConfigUtils._configData?.deliveryMapping;
    }
    /**
     * Get Preset Filters
     * @returns PresetFilters
     */
    static getPresetFilters() {
        return ConfigUtils._configData.presetFilters;
    }
    /**
     * Get Job Types
     * @returns JobTypes
     */
    static getJobTypes() {
        return ConfigUtils._configData?.jobType;
    }
    /**
     * Get QC Fields
     * @returns QCFields
     */
     static getQCFields() {
        return ConfigUtils._configData['qc-fields'];
    }
    /**
     * Get Statuses
     * @returns Statuses
     */
    static getStatuses() {
        return ConfigUtils._configData?.statuses;
    }
    /**
     * Get Status Change Rules
     * @returns StatusChangeRules
     */
    static getStatusChangeRules() {
        return ConfigUtils._configData['status-change-rules'];
    }
    /**
     * Get Read Only Components
     * @returns ReadOnlyComponents
     */
    static getReadOnlyComponents() {
        return ConfigUtils._configData.readOnlyComponents;
    }
    /**
     * Get Intended Use File
     * @returns IntendedUseFile
     */
    static getIntendedUseFile() {
        return ConfigUtils._configData.intendedUseFile;
    }
    /**
     * Get Frame Rates
     * @returns FrameRates
     */
    static getFrameRates() {
        return ConfigUtils._configData['frame-rate-types'];
    }
    /**
     * Get Custom Filters
     * @returns CustomFilters
     */
     static getCustomFilters() {
        return ConfigUtils._configData?.customFilters;
    }
    /**
     * Get Socket Messages
     * @returns SocketMessages
     */
     static getSocketMessages() {
        return ConfigUtils._configData?.socketMessages;
    }
    /**
     * Get Transfer Regions
     * @returns TransferRegion
     */
    static getTransferRegions() {
        return ConfigUtils._configData?.transferRegion;
    }
    /**
     * Get source locations
     * @returns SourceLocations
     */
    static getSourceLocations() {
        return ConfigUtils._configData?.sourceLocations;
    }
    /**
     * Get Transfer Regions
     * @returns TransferRegion
     */
    static getAocConfigs() {
        return ConfigUtils._configData?.aocConfigs;
    }
    /**
     * Set all UI configs at a time. If no data is passed, using existing configs files on UI
     * @param data Config data
     */
    static setConfig(data?) {
        ConfigUtils._configData = data;
    }
}
